/**
 * Retail / storefront title case for labels shown to customers (categories, product types,
 * hub tiles, breadcrumbs). Each word is capitalized; hyphen-separated segments are handled;
 * pure numeric tokens are unchanged. Leading punctuation (e.g. "(") does not block casing.
 * Does not modify stored catalog data.
 */
export function formatDisplayTitle(text) {
  if (text == null || typeof text !== 'string') return '';
  let t = text.trim();
  if (!t) return '';
  t = t.replace(/\s*[\u2013\u2014]\s*/g, ' ');

  return t.replace(/[^\s-]+/g, (word) => titleCaseToken(word));
}

function titleCaseToken(word) {
  if (!word) return word;
  if (/^\d+$/.test(word)) return word;

  const letterIdx = word.search(/[a-zA-Z]/);
  if (letterIdx < 0) return word;

  return (
    word.slice(0, letterIdx) +
    word.charAt(letterIdx).toUpperCase() +
    word.slice(letterIdx + 1).toLowerCase()
  );
}

/**
 * Title from an uploaded file name — strips extension and splits on hyphens/underscores,
 * then applies storefront title case. e.g. "photoshoot-3.png" → "Photoshoot 3".
 */
export function titleFromUploadFilename(filename) {
  if (filename == null || typeof filename !== 'string') return '';
  let base = filename.trim();
  if (!base) return '';
  base = base.replace(/\\/g, '/');
  const slash = base.lastIndexOf('/');
  if (slash >= 0) base = base.slice(slash + 1);
  base = base.replace(/\.[^.]+$/, '');
  base = base.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!base) return '';
  return formatDisplayTitle(base);
}

/** @deprecated Use formatDisplayTitle; kept for existing imports. */
export const formatProductTitle = formatDisplayTitle;
